module.exports = __webpack_public_path__ + "img/3.fd3f885.png";